import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function DHBackdrop(_props: any) {
//   const [open, setOpen] = React.useState(props.open);
//   const handleClose = () => {
//     setOpen(false);
//   };

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* {open && <p>Load</p>} */}
    </div>
  );
}